import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Label, StyledChip } from './Chip.styles';
export const Chip = /*#__PURE__*/ forwardRef(({ backgroundColor, label, textColor, ...props }, ref)=>/*#__PURE__*/ _jsx(StyledChip, {
        $background: backgroundColor,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ _jsx(Label, {
            $color: textColor,
            children: label
        })
    }));

//# sourceMappingURL=Chip.js.map